export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <span className="brand-mark" aria-label="HostelGrid">
      <img
        className={compact ? 'brand-logo-image compact' : 'brand-logo-image full'}
        src={compact ? '/brand/hostelgrid-mark.png' : '/brand/hostelgrid-logo.png'}
        alt=""
        aria-hidden="true"
        width={compact ? 512 : 1040}
        height={compact ? 512 : 600}
        loading="eager"
        decoding="async"
      />
    </span>
  );
}
